import { createRouter, createWebHistory } from "vue-router";
import InscriptionView from "../views/InscriptionView.vue";
import HomeView from "../views/HomeView.vue";
import LoginView from "../views/Login.vue";
import DashboardView from "../views/Dashboard.vue";
import NeolinkView from "../views/Neolink.vue";
import NeolinkDjibView from "../views/Neolinkdjib.vue";
import ConfirmationView from "../views/ConfirmationView.vue";
import AdminLogin from '../views/admin/AdminLogin.vue';
import AdminDashboard from '../views/admin/AdminDashboard.vue';

// Middleware de vérification admin
const requireAdmin = (to, from, next) => {
  const user = JSON.parse(localStorage.getItem('user'));
  if (user && user.is_admin === 1) {
    next();
  } else {
    next({ name: 'AdminLogin' });
  }
};

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  // Route directe pour /djib
  {
    path: "/djib",
    name: "Djib",
    component: NeolinkDjibView,

  },
  // La route originale /neolink/djib est maintenue également
  {
    path: '/neolink/djib',
    name: 'NeolinkDjib',
    component: NeolinkDjibView,

  },
  // ✅ MODIFIER cette route pour accepter le code de parrainage
  {
    path: '/inscription/:referralCode?', // ✅ Paramètre optionnel ajouté
    name: 'Inscription',
    component: InscriptionView
  },
  
  // ✅ AJOUTER route de redirection pour liens affiliés
  {
    path: '/ref/:code',
    redirect: to => `/inscription/${to.params.code}`
  },
  
  {
    path: "/connexion",
    name: "connexion",
    component: LoginView,
  },
  {
    path: "/confirm/:token",
    name: "confirmation",
    component: ConfirmationView,
    meta: {
      title: 'Confirmer votre compte - neolinks'
    }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: DashboardView,
  },
  {
    path: '/payment-success',
    name: 'PaymentSuccess',
    component: () => import('../views/PaymentSuccess.vue')
  },
  {
    path: '/payment-failure',
    name: 'PaymentFailure',
    component: () => import('../views/PaymentFailure.vue')
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('../views/ForgotPassword.vue')
  },
  {
    path: '/reset-password/:token',
    name: 'ResetPassword',
    component: () => import('../views/ResetPassword.vue')
  },
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: AdminLogin,
  },
  {
    path: '/admin',
    name: 'AdminDashboard',
    component: AdminDashboard,
    beforeEnter: requireAdmin
  },
  {
    path: '/admin/dashboard',
    redirect: '/admin'
  },
  {
    path: '/admin/users',
    name: 'AdminUsers',
    component: () => import('../views/admin/AdminUsers.vue'),
    beforeEnter: requireAdmin
  },
  {
    path: '/admin/subscriptions',
    name: 'AdminSubscriptions',
    component: () => import('../views/admin/AdminSubscriptions.vue'),
    beforeEnter: requireAdmin
  },
  {
    path: '/admin/payments',
    name: 'AdminPayments',
    component: () => import('../views/admin/AdminPayments.vue'),
    beforeEnter: requireAdmin
  },
  // Cette route doit rester en dernier (route générique)
  {
    path: '/:username',
    name: 'Neolink',
    component: NeolinkView,
    // Ne pas intercepter les routes connues
    beforeEnter: (to, from, next) => {
      const reservedRoutes = ['inscription', 'connexion', 'dashboard', 'neolink', 'djib'];
      if (reservedRoutes.includes(to.params.username)) {
        next({ name: to.params.username });
      } else {
        next();
      }
    }
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
        top: 80 // Hauteur du menu fixe
      }
    }
    return { top: 0 }
  }
})

// Mise à jour du titre de la page
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'neolinks'
  next()
})

export default router;